import { BUILD_RADIUS, canPlace } from '../sim/build';
import { TILE } from '../sim/constants';
import type { Grid } from '../sim/path';
import type { GameState } from '../sim/types';

/*
 * שטח ההצבה — אילו אריחים חוקיים למבנה שממתין.
 *
 * **הוא קיים כי בלעדיו ההצבה היא ניחוש.** `canPlace` דורש שני תנאים שאינם נראים
 * על המסך בכלל: שכל אריחי המבנה פנויים ועבירים, **וגם** שהמבנה בטווח בנייה ממבנה
 * קיים. בר הקיש על המפה, שום דבר לא קרה, ולא הייתה שום דרך להבין למה.
 *
 * הפונקציה חיה כאן ולא ב-`Battlefield` כדי שאפשר יהיה לבדוק אותה בלי DOM ובלי
 * קנבס — היא הלוגיקה, לא הציור.
 */

/**
 * כל האריחים שבהם מותר להציב את `type` עבור `player`.
 * הסריקה מוגבלת לסביבת המבנים הקיימים, כי טווח הבנייה ממילא נמדד מהם.
 */
export function placementTiles(
    state: GameState,
    grid: Grid,
    player: number,
    type: number,
    mapW: number,
    mapH: number,
): number[] {
    const reach = Math.ceil(BUILD_RADIUS / TILE) + 1;
    const tiles = new Set<number>();

    for (const building of state.buildings) {
        if (building.owner !== player || building.hp <= 0) continue;
        for (let dy = -reach; dy <= reach; dy++) {
            for (let dx = -reach; dx <= reach; dx++) {
                const x = building.tileX + dx;
                const y = building.tileY + dy;
                if (x < 0 || y < 0 || x >= mapW || y >= mapH) continue;
                const index = y * mapW + x;
                if (tiles.has(index)) continue;
                if (canPlace(state, grid, player, type, x, y)) tiles.add(index);
            }
        }
    }

    // סדר קבוע: הציור לא אמור להבהב בין פריימים רק בגלל סדר איטרציה של Set.
    return [...tiles].sort((a, b) => a - b);
}
